/* eslint-disable @typescript-eslint/no-explicit-any -- legacy stuffing response shapes */
import { useMemo } from "react";
import { Cell, Pie, PieChart } from "recharts";
import { generateId } from "utils/utils";
import styles from "./StuffingDetailed.module.scss";

interface StuffingChartProps {
  productsData: any[];
  filledPercent?: number;
  emptyVolume?: number;
}

export const StuffingChart = ({ productsData, filledPercent = 0, emptyVolume = 0 }: StuffingChartProps) => {
  const chartData = useMemo(() => {
    const items = productsData.map((item) => ({
      name: item.name,
      volume: item.volume,
      color: item.color,
    }));

    if (emptyVolume > 0) {
      items.push({
        name: "empty",
        volume: emptyVolume,
        color: "#EFF1F6",
      });
    }

    return items.length
      ? items
      : [
          {
            name: "empty",
            volume: 1,
            color: "#EFF1F6",
          },
        ];
  }, [productsData, emptyVolume]);

  return (
    <div className={styles.chart}>
      <PieChart width={120} height={120}>
        <Pie
          data={chartData}
          cx={60}
          cy={60}
          innerRadius={40}
          outerRadius={55}
          paddingAngle={2}
          dataKey="volume"
          stroke="none"
        >
          {chartData.map((item) => (
            <Cell key={generateId()} fill={item.color} />
          ))}
        </Pie>
      </PieChart>
      <div className={styles.chartLabel}>
        <span className={styles.chartPercent}>{filledPercent}%</span>
        <span className={styles.chartFilled}>filled</span>
      </div>
    </div>
  );
};
